export const TABLE_VARIANTS = {
  COMPLETO: "completo",
  PENDIENTE: "pendientes",
};
